(function () {
  'use strict';

  angular
    .module('relatorios.identificacoes', [
      'ui.router',
      'angularMoment',
      'FactoryVfiltroModule',
      'ServiceVfiltroModule',
      'ProntuarioLinkModule',
      'ConstantVfiltroModule'
    ]);
}());
